import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'


import RepairmenList from './RepairmenList'
import RepairmanForm from '../repairmanForm'
import repairmen from 'selectors/repairmen'
import { properties } from 'selectors/entities'

import mobileActions from 'actions/mobile'
import actionBarActions from 'actions/actionbar'
import repairmenFiltersActions from 'actions/repairmenFilters'
import rightStackActions from 'actions/rightStackActions'
import attachmentOverlayActions from 'actions/attachmentOverlayActions'
import yelpActions from 'actions/yelp'
import dataActions from 'actions/dataActions'
import Error from 'components/Error'
import loginActions from 'actions/login'

let select = (state) => ({
    ...state
  , repairmen: repairmen(state)
  , properties: properties(state)
  })
export class Repairmen extends Component {
	render() {
		try{
			return(

						<RepairmenList
							repairmen={this.props.repairmen}
							openPanel={this.props.OPEN_PANEL}
							filtersIsOpened={this.props.actionBarReducers.rightNav}
							rightStackOpened={!!this.props.routeParams.id}
							navPanelIsOpened={this.props.actionBarReducers.leftNav}
							lastInteracted={(this.props.routeParams.id)?
								this.props.routeParams.id
								: ''
							}
							count={R.values(this.props.repairmen).length}
							refTask={(this.props.routing.locationBeforeTransitions.state && this.props.routing.locationBeforeTransitions.state.refTask)?this.props.routing.locationBeforeTransitions.state.refTask: undefined}
							refQuoteProject={(this.props.routing.locationBeforeTransitions.state && this.props.routing.locationBeforeTransitions.state.refQuoteProject)?this.props.routing.locationBeforeTransitions.state.refQuoteProject: undefined}
							docUpd = {this.props.DOC_UPDATE}
							stage={this.props.STAGE}
							history = {this.props.history}
							property={this.props.repairmenFilters.property}
							properties={this.props.properties}
							docUpd={this.props.DOC_UPDATE}
							filtersUPD={this.props.REPAIRMEN_FILTER_UPDATED}
							repairmenFilters={this.props.repairmenFilters}
							data={this.props.data}
							switchYelp={this.props.SWITCH_YELP}
							yelpIsOn={this.props.yelp.isOn}
							updCategoryYelp={this.props.CHANGE_CATEGORY}
							yelpCategory={this.props.yelp.category}
							filters={this.props.actionBarReducers.rightNav}
							toggleFilt={this.props.TOOGLE_FILTERS_PANEL}
							repairmenSelect={false}
						/>

			)
		}catch(err){
			console.error(err)
			return(<Error />)
		}
	}
}

export default connect(select, R.mergeAll([actionBarActions, repairmenFiltersActions, mobileActions, loginActions, yelpActions, rightStackActions, attachmentOverlayActions, dataActions]))(Repairmen)



// WEBPACK FOOTER //
// ./src/routes/manager/repairmen/index.js